<script setup lang="ts">
import { onErrorCaptured, ref } from 'vue';
import AppButton from '@/shared/ui/AppButton.vue';

/**
 * WEB-007 — a render failure in one view degrades to a recovery panel instead of leaving
 * a blank page. A user who sees nothing has no idea whether to wait, reload or give up.
 */
const failure = ref<Error | null>(null);

onErrorCaptured((error) => {
  failure.value = error instanceof Error ? error : new Error(String(error));
  // Stops propagation so a single broken view does not unmount the whole application.
  return false;
});

function retry(): void {
  failure.value = null;
}
</script>

<template>
  <div
    v-if="failure"
    role="alert"
    class="mx-auto my-10 max-w-lg rounded-card border border-danger-600/30 bg-surface p-6 text-center"
  >
    <h2 class="text-lg font-semibold text-ink">
      No pudimos mostrar esta sección
    </h2>
    <p class="mt-2 text-sm text-ink-muted">
      Ocurrió un inconveniente al presentar la información. Puede intentar nuevamente o volver al
      inicio.
    </p>
    <div class="mt-5 flex flex-col justify-center gap-2 sm:flex-row">
      <AppButton @click="retry">
        Reintentar
      </AppButton>
      <AppButton
        variant="secondary"
        @click="$router.push('/')"
      >
        Ir al inicio
      </AppButton>
    </div>
  </div>

  <slot v-else />
</template>
